import * as types from "../constants/postConstants";
import { LOGOUT } from "../constants/authConstants";

const initialState = {
  post: null,
  posts: [],
  publicPosts: [],
  totalPublicPosts: 0,
  ownPost: null,
  savedPosts: [],
  totalSavedPosts: 0,
  privatePosts: [],
  totalPrivatePosts: 0,
  totalPosts: 0,
  communityPosts: [],
  followingUsersPosts: [],
  followingPosts: [],
  totalFollowingPosts: 0,
  totalCommunityPosts: 0,
  skillsFeedPosts: [],
  totalSkillsFeedPosts: 0,
  postError: null,
  postCategory: null,
  confirmationToken: null,
  isPostInappropriate: false,
  isCommentInappropriate: false,
};

const postsReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOGOUT:
      return {
        ...state,
        post: null,
        posts: [],
        publicPosts: [],
        ownPost: null,
        savedPosts: [],
        privatePosts: [],
        totalPosts: 0,
        communityPosts: [],
        followingUsersPosts: [],
        followingPosts: [],
        totalFollowingPosts: 0,
        totalCommunityPosts: 0,
        postError: null,
        commentError: null,
        postCategory: null,
        confirmationToken: null,
        isPostInappropriate: false,
        isCommentInappropriate: false,
      };

    case types.CREATE_POST_SUCCESS:
    case types.CONFIRM_POST_SUCCESS:
      return {
        ...state,
        posts: [payload, ...state.posts],
        communityPosts: [payload, ...state.communityPosts],
        skillsFeedPosts: [payload, ...state.skillsFeedPosts],
        postError: null,
        postCategory: null,
        confirmationToken: null,
        isPostInappropriate: false,
      };

    case types.CREATE_POST_FAIL:
    case types.CONFIRM_POST_FAIL:
      return {
        ...state,
        postError: payload,
      };

    case types.CREATE_POST_FAIL_INAPPROPRIATE:
      return {
        ...state,
        isPostInappropriate: true,
      };

    case types.CREATE_POST_FAIL_DETECT_CATEGORY:
      return {
        ...state,
        confirmationToken: payload,
      };

    case types.CREATE_POST_FAIL_CATEGORY_MISMATCH:
      return {
        ...state,
        postCategory: payload,
      };

    case types.CLEAR_CREATE_POST_FAIL:
      return {
        ...state,
        postError: null,
        postCategory: null,
        confirmationToken: null,
        isPostInappropriate: false,
      };

    case types.GET_POST_SUCCESS:
      return {
        ...state,
        post: payload,
        postError: null,
      };
    case types.GET_POST_FAIL:
      return {
        ...state,
        postError: payload,
      };

    case types.GET_OWN_POST_SUCCESS:
      return {
        ...state,
        ownPost: payload,
        postError: null,
      };
    case types.GET_OWN_POST_FAIL:
      return {
        ...state,
        postError: payload,
      };

    case types.CLEAR_POST:
      return {
        ...state,
        post: null,
        comments: [],
        postError: null, // Clear error when clearing post
      };

    case types.CLEAR_POSTS:
      return {
        ...state,
        posts: [],
        totalPosts: 0,
      };

    case types.CLEAR_COMMUNITY_POSTS:
      return {
        ...state,
        communityPosts: [],
        totalCommunityPosts: 0,
      };

    case types.GET_POSTS_SUCCESS:
      if (payload.page === 1) {
        return {
          ...state,
          posts: payload ? payload.posts : [],
          totalPosts: payload ? payload.totalPosts : 0,
          postError: null,
        };
      } else {
        const existingPosts = state.posts.map((post) => post._id);
        const newPosts = (payload ? payload.posts : []).filter(
          (post) => !existingPosts.includes(post._id)
        );
        return {
          ...state,
          posts: [...state.posts, ...newPosts],
          totalPosts: payload ? payload.totalPosts : 0,
          postError: null,
        };
      }

    case types.GET_POSTS_FAIL:
      return {
        ...state,
        postError: payload,
      };

    case types.GET_COMMUNITY_POSTS_SUCCESS:
      if (payload.page === 1) {
        return {
          ...state,
          communityPosts: payload ? payload.posts : [],
          totalCommunityPosts: payload ? payload.totalCommunityPosts : 0,
          postError: null,
        };
      } else {
        return {
          ...state,
          communityPosts: [
            ...state.communityPosts,
            ...(payload ? payload.posts : []),
          ],
          totalCommunityPosts: payload ? payload.totalCommunityPosts : 0,
          postError: null,
        };
      }

    case types.GET_COMMUNITY_POSTS_FAIL:
      return {
        ...state,
        postError: payload,
      };

    case types.GET_FOLLOWING_USERS_POSTS_SUCCESS:
      return {
        ...state,
        followingUsersPosts: payload ? payload : [],
        postError: null,
      };

    case types.GET_FOLLOWING_USERS_POSTS_FAIL:
      return {
        ...state,
        postError: payload,
      };

    case types.GET_FOLLOWING_POSTS_SUCCESS:
      if (payload.page === 1) {
        return {
          ...state,
          followingPosts: payload ? payload.posts : [],
          totalFollowingPosts: payload ? payload.totalPosts : 0,
          postError: null,
        };
      } else {
        const existingPosts = state.followingPosts.map((post) => post._id);
        const newPosts = payload.posts.filter(
          (post) => !existingPosts.includes(post._id)
        );
        return {
          ...state,
          followingPosts: [...state.followingPosts, ...newPosts],
          totalFollowingPosts: payload.totalPosts,
          postError: null,
        };
      }

    case types.GET_FOLLOWING_POSTS_FAIL:
      return {
        ...state,
        postError: payload,
      };

    case types.CLEAR_FOLLOWING_POSTS:
      return {
        ...state,
        followingPosts: [],
        totalFollowingPosts: 0,
        postError: null,
      };

    case types.GET_SKILLS_FEED_POSTS_SUCCESS:
      if (payload.page === 1) {
        return {
          ...state,
          skillsFeedPosts: payload ? payload.posts : [],
          totalSkillsFeedPosts: payload ? payload.totalPosts : 0,
          postError: null,
        };
      } else {
        const existingPosts = state.skillsFeedPosts.map((post) => post._id);
        const newPosts = payload.posts.filter(
          (post) => !existingPosts.includes(post._id)
        );
        return {
          ...state,
          skillsFeedPosts: [...state.skillsFeedPosts, ...newPosts],
          totalSkillsFeedPosts: payload.totalPosts,
          postError: null,
        };
      }
    case types.GET_SKILLS_FEED_POSTS_FAIL:
      return {
        ...state,
        postError: payload,
      };

    case types.UPDATE_POST_SUCCESS:
      return {
        ...state,
        posts: state.posts.map((post) =>
          post._id === payload._id ? payload : post
        ),
        communityPosts: state.communityPosts.map((post) =>
          post._id === payload._id ? payload : post
        ),
        savedPosts: state.savedPosts.map((post) =>
          post._id === payload._id ? payload : post
        ),
        privatePosts: state.privatePosts.map((post) =>
          post._id === payload._id ? payload : post
        ),
        publicPosts: state.publicPosts.map((post) =>
          post._id === payload._id ? payload : post
        ),
        skillsFeedPosts: state.skillsFeedPosts.map((post) =>
          post._id === payload._id ? payload : post
        ),
        followingPosts: state.followingPosts.map((post) =>
          post._id === payload._id ? payload : post
        ),
        postError: null,
      };

    case types.DELETE_POST_SUCCESS:
      return {
        ...state,
        posts: state.posts.filter((post) => post._id !== payload),
        communityPosts: state.communityPosts.filter(
          (post) => post._id !== payload
        ),
        skillsFeedPosts: state.skillsFeedPosts.filter(
          (post) => post._id !== payload
        ),
        followingPosts: state.followingPosts.filter(
          (post) => post._id !== payload
        ),
        postError: null,
        totalPosts: state.totalPosts - 1,
        totalCommunityPosts: state.totalCommunityPosts - 1,
        totalSkillsFeedPosts: state.totalSkillsFeedPosts - 1,
        totalFollowingPosts: state.totalFollowingPosts - 1,
      };
    case types.DELETE_POST_FAIL:
      return {
        ...state,
        postError: payload,
      };

    case types.UPDATE_POST_FAIL:
      return {
        ...state,
        postError: payload,
      };

    case types.ADD_COMMENT_FAIL:
      return {
        ...state,
        commentError: payload,
      };

    case types.ADD_COMMENT_FAIL_INAPPROPRIATE:
      return {
        ...state,
        isCommentInappropriate: true,
      };

    case types.CLEAR_COMMENT_FAIL:
      return {
        ...state,
        commentError: null,
        isCommentInappropriate: false,
      };

    case types.LIKE_POST_SUCCESS:
    case types.UNLIKE_POST_SUCCESS:
      const { posts, communityPosts, skillsFeedPosts, followingPosts } = updatePostLike(state, payload);
      return {
        ...state,
        posts,
        communityPosts,
        skillsFeedPosts,
        followingPosts,
        postError: null,
      };
    case types.LIKE_POST_FAIL:
    case types.UNLIKE_POST_FAIL:
      return {
        ...state,
        postError: payload,
      };

    case types.SAVE_POST_SUCCESS:
    case types.UNSAVE_POST_SUCCESS:
    case types.GET_SAVED_POSTS_SUCCESS:
      if (payload.page === 1) {
        return {
          ...state,
          savedPosts: payload.posts || [],
          totalSavedPosts: payload.totalPosts || 0,
          postError: null,
        };
      } else {
        return {
          ...state,
          savedPosts: [
            ...state.savedPosts,
            ...(payload.posts || []),
          ],
          totalSavedPosts: payload.totalPosts || 0,
          postError: null,
        };
      }
    case types.SAVE_POST_FAIL:
    case types.UNSAVE_POST_FAIL:
    case types.GET_SAVED_POSTS_FAIL:
      return {
        ...state,
        postError: payload,
      };

    case types.GET_PRIVATE_POSTS_SUCCESS:
      if (payload.page === 1) {
        return {
          ...state,
          privatePosts: payload.posts || [],
          totalPrivatePosts: payload.totalPosts || 0,
          postError: null,
        };
      } else {
        return {
          ...state,
          privatePosts: [
            ...state.privatePosts,
            ...(payload.posts || []),
          ],
          totalPrivatePosts: payload.totalPosts || 0,
          postError: null,
        };
      }
    case types.GET_PRIVATE_POSTS_FAIL:
      return {
        ...state,
        postError: payload,
      };

    case types.GET_PUBLIC_POSTS_SUCCESS:
      if (payload.page === 1) {
        return {
          ...state,
          publicPosts: payload.posts || [],
          totalPublicPosts: payload.totalPosts || 0,
          postError: null,
        };
      } else {
        return {
          ...state,
          publicPosts: [
            ...state.publicPosts,
            ...(payload.posts || []),
          ],
          totalPublicPosts: payload.totalPosts || 0,
          postError: null,
        };
      }
    case types.GET_PUBLIC_POSTS_FAIL:
      return {
        ...state,
        postError: payload,
      };
    case types.INCREASE_SAVED_BY_COUNT:
      return {
        ...state,
        post:
          state.post && state.post._id === payload
            ? {
                ...state.post,
                savedByCount: state.post.savedByCount + 1,
              }
            : state.post,

        postError: null,
      };
    case types.DECREASE_SAVED_BY_COUNT:
      return {
        ...state,
        post:
          state.post && state.post._id === payload
            ? {
                ...state.post,
                savedByCount: state.post.savedByCount - 1,
              }
            : state.post,

        postError: null,
      };

    case types.REPORT_POST_SUCCESS:
      const { postId } = payload;
      const wasInPosts = state.posts.some((post) => post._id === postId);
      const wasInCommunityPosts = state.communityPosts.some((post) => post._id === postId);
      const wasInSkillsFeedPosts = state.skillsFeedPosts.some((post) => post._id === postId);
      const wasInFollowingPosts = state.followingPosts.some((post) => post._id === postId);
      const wasInPublicPosts = state.publicPosts.some((post) => post._id === postId);
      const wasInPrivatePosts = state.privatePosts.some((post) => post._id === postId);
      const wasInSavedPosts = state.savedPosts.some((post) => post._id === postId);
      
      return {
        ...state,
        posts: state.posts.filter((post) => post._id !== postId),
        communityPosts: state.communityPosts.filter(
          (post) => post._id !== postId
        ),
        skillsFeedPosts: state.skillsFeedPosts.filter(
          (post) => post._id !== postId
        ),
        followingPosts: state.followingPosts.filter(
          (post) => post._id !== postId
        ),
        publicPosts: state.publicPosts.filter(
          (post) => post._id !== postId
        ),
        privatePosts: state.privatePosts.filter(
          (post) => post._id !== postId
        ),
        savedPosts: state.savedPosts.filter(
          (post) => post._id !== postId
        ),
        followingUsersPosts: state.followingUsersPosts.filter(
          (post) => post._id !== postId
        ),
        post: state.post && state.post._id === postId ? null : state.post,
        totalPosts: wasInPosts ? Math.max(0, state.totalPosts - 1) : state.totalPosts,
        totalCommunityPosts: wasInCommunityPosts ? Math.max(0, state.totalCommunityPosts - 1) : state.totalCommunityPosts,
        totalSkillsFeedPosts: wasInSkillsFeedPosts ? Math.max(0, state.totalSkillsFeedPosts - 1) : state.totalSkillsFeedPosts,
        totalFollowingPosts: wasInFollowingPosts ? Math.max(0, state.totalFollowingPosts - 1) : state.totalFollowingPosts,
        totalPublicPosts: wasInPublicPosts ? Math.max(0, state.totalPublicPosts - 1) : state.totalPublicPosts,
        totalPrivatePosts: wasInPrivatePosts ? Math.max(0, state.totalPrivatePosts - 1) : state.totalPrivatePosts,
        totalSavedPosts: wasInSavedPosts ? Math.max(0, state.totalSavedPosts - 1) : state.totalSavedPosts,
        postError: null,
      };

    case types.REPORT_POST_FAIL:
      return {
        ...state,
        postError: payload,
      };

    default:
      return state;
  }
};

const updatePostLike = (state, updatedPost) => {
  const posts = state.posts.map((post) =>
    post._id === updatedPost._id ? updatedPost : post
  );
  const communityPosts = state.communityPosts.map((post) =>
    post._id === updatedPost._id ? updatedPost : post
  );
  const skillsFeedPosts = state.skillsFeedPosts.map((post) =>
    post._id === updatedPost._id ? updatedPost : post
  );
  const followingPosts = state.followingPosts.map((post) =>
    post._id === updatedPost._id ? updatedPost : post
  );
  return { posts, communityPosts, skillsFeedPosts, followingPosts };
};

export default postsReducer;
